/**
 * CAUCARED Soluciones Informáticas — la marca hermana, dentro del mismo sistema pero aparte.
 *
 * Todo lo de aquí vive en /caucared/... y en tablas cau_ del servidor. Nada entra a Dinero,
 * Caja, Ventas ni Cartera de LinkUs. El menú, los colores y la franja de arriba cambian al
 * entrar (ver Layout) para que no haya forma de confundir en cuál empresa se está.
 */
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate, useSearchParams, Navigate } from 'react-router-dom';
import Layout from '../../components/Layout';
import api from '../../services/api';
import { useAuth } from '../../context/AuthContext';
import CauDocumentos from './CauDocumentos';
import { CauClientes, CauCartera, CauReporte, CauConfig } from './CauSecciones';
import { CAU, est, mensajeDeError } from './cauComun';

export const SECCIONES_CAU = [
  { id: 'cotizaciones',  txt: 'Cotizaciones', icon: '📝' },
  { id: 'facturas',      txt: 'Facturas',     icon: '🧾' },
  { id: 'cartera',       txt: 'Cartera',      icon: '💼' },
  { id: 'clientes',      txt: 'Clientes',     icon: '🏢' },
  { id: 'reporte',       txt: 'Reporte',      icon: '📈' },
  { id: 'configuracion', txt: 'Configuración', icon: '⚙' },
];

export default function Caucared() {
  const { seccion = 'cotizaciones' } = useParams();
  const [params] = useSearchParams();
  const navigate = useNavigate();
  const { usuario } = useAuth();
  const [cfg, setCfg] = useState(null);
  const [error, setError] = useState('');
  const esSuper = usuario?.rol === 'superadmin';

  useEffect(() => {
    api.get('/api/caucared/config').then(({ data }) => setCfg(data))
      .catch((e) => setError(mensajeDeError(e, 'No se pudo cargar CAUCARED')));
  }, []);

  if (!['admin', 'superadmin'].includes(usuario?.rol)) return <Navigate to="/dashboard" replace />;
  if (!SECCIONES_CAU.some((s) => s.id === seccion)) return <Navigate to="/caucared/cotizaciones" replace />;

  const verId = params.get('ver');
  const irAFactura = (id) => navigate(`/caucared/facturas?ver=${id}`);
  const faltanDatos = cfg && !cfg.nit;

  let contenido = null;
  if (cfg) {
    // La llave obliga a empezar de cero al cambiar de documento o de filtro desde otra sección
    const llave = `${seccion}-${verId || ''}-${params.get('q') || ''}`;
    if (seccion === 'cotizaciones') contenido = <CauDocumentos key={llave} tipo="cotizacion" cfg={cfg} verId={verId} onVerFactura={irAFactura} />;
    if (seccion === 'facturas') contenido = <CauDocumentos key={llave} tipo="factura" cfg={cfg} verId={verId} qInicial={params.get('q')} onVerFactura={irAFactura} />;
    if (seccion === 'cartera') contenido = <CauCartera onVerFactura={irAFactura} />;
    if (seccion === 'clientes') contenido = <CauClientes onVerFacturas={(c) => navigate(`/caucared/facturas?q=${encodeURIComponent(c.razon_social)}`)} />;
    if (seccion === 'reporte') contenido = <CauReporte />;
    if (seccion === 'configuracion') contenido = <CauConfig cfg={cfg} esSuper={esSuper} onGuardado={setCfg} />;
  }

  return (
    <Layout>
      <div style={{ maxWidth: '1100px', margin: '0 auto', minWidth: 0 }}>
        <div style={{ display: 'flex', gap: '6px', overflowX: 'auto', marginBottom: '16px', paddingBottom: '2px' }}>
          {SECCIONES_CAU.map((s) => {
            const activa = s.id === seccion;
            return (
              <button key={s.id} onClick={() => navigate(`/caucared/${s.id}`)}
                style={{ flexShrink: 0, background: activa ? CAU.acentoSuave : 'transparent', color: activa ? CAU.acento : 'rgba(255,255,255,0.65)',
                  border: `1px solid ${activa ? CAU.borde : CAU.lineas}`, borderRadius: '20px', padding: '7px 14px', fontSize: '13px',
                  fontWeight: activa ? 700 : 500, cursor: 'pointer' }}>
                {s.icon} {s.txt}
              </button>
            );
          })}
        </div>
        {faltanDatos && seccion !== 'configuracion' && (
          <div style={{ ...est.tarjeta, borderColor: CAU.borde, fontSize: '13px', marginBottom: '14px', display: 'flex', gap: '10px', alignItems: 'center', flexWrap: 'wrap' }}>
            <span style={{ flex: 1 }}>Falta el NIT de CAUCARED: los documentos salen sin él.</span>
            {esSuper && <button style={est.botonSec} onClick={() => navigate('/caucared/configuracion')}>Completar</button>}
          </div>
        )}
        {error && <div style={est.error}>{error}</div>}
        {!cfg && !error && <div style={{ color: CAU.tenue }}>Cargando…</div>}
        {contenido}
      </div>
    </Layout>
  );
}
